// @ts-nocheck
import {Grid} from "@mui/material";
import {ProductCard} from "app/components/ProductCard";
import * as React from "react";
import {Api} from "../../../store/api";
import { useState, useCallback, useEffect} from "react";
import styled from "styled-components/macro";
import { Switch } from '@mui/material';
import { useOutletContext } from "react-router-dom";

interface PricingTableProps {
  small?: boolean;
  isCheckboxSelectMode?: boolean;
  hideCurrentPlan?: boolean;
  hideFreePlan?: boolean;
  hideContractCard?: boolean;
}

export function PricingTable(props: PricingTableProps) {
    const [isRedirectingToCreatorPlan, setIsRedirectingToCreatorPlan] = useState(false);
    const [isRedirectingToStarterPlan, setIsRedirectingToStarterPlan] = useState(false);
    const [yearlyToggleValue, setYearlyToggleValue] = useState(true);

    const { isCheckboxSelectMode = false, small = false, hideCurrentPlan = false, hideFreePlan = false, hideContractCard = false } = props;

    // Calculate column width based on which cards are hidden
    const getColumnWidth = () => {
        if (hideFreePlan && hideContractCard) return 6;  // When both free and contract are hidden
        return 4;  // When both are shown
    };

    const columnWidth = getColumnWidth();

    // Get user subscription status 
    const [userProfile, isLoaded, isSignedIn, refetchUser] = useOutletContext();
    const isCreator = userProfile?.plan?.includes('creator') || false;
    const inferenceCredits = userProfile?.inference_credits || 0;
    const isStarter = userProfile?.plan?.includes('starter') || false;

    // Create selectedPlan state to store which plan is checked
    const [selectedPlan, setSelectedPlan] = useState<"creator" | "starter">("creator");
    const handleCheckboxPlanSelection = (plan: "creator" | "starter") => {
        // dont select starter if already starter
        if (plan === "starter" && isStarter) {
            return;
        }
        setSelectedPlan(plan);
    }

    const handleClickCreatorPlan = async () => {
        setIsRedirectingToCreatorPlan(true)
        // Track tiktok event
        // @ts-ignore
        window.ttq.track('InitiateCheckout', {
            content_type: 'product',
            content_id: 'creator-plan',
            content_name: 'Creator Plan',
            currency: 'USD',
            price: '30.00',
            quantity: 1,
            value: '30.00',
        })
        await Api.redirectToCreatorCheckout(yearlyToggleValue)
        setIsRedirectingToCreatorPlan(false)
    }

    const handleClickStarterPlan = async () => {
        setIsRedirectingToStarterPlan(true)
        // Track tiktok event
        // @ts-ignore
        window.ttq.track('InitiateCheckout', {
            content_type: 'product',
            content_id: 'starter-plan',
            content_name: 'Starter Plan',
            currency: 'USD',
            price: '12.00',
            quantity: 1,
            value: '12.00',
        })
        await Api.redirectToStarterCheckout(yearlyToggleValue)
        setIsRedirectingToStarterPlan(false)
    }

    const onToggleYearly = () => {
        setYearlyToggleValue(!yearlyToggleValue)
    }

    const starterPlanPrice = yearlyToggleValue ? "$8" : "$12"
    const creatorPlanPrice = yearlyToggleValue ? "$20" : "$30"

      
    // To handle the "upgrade now" button
    const handleUpgradeClick = async () => {
        
        if (selectedPlan === "creator") {
            await handleClickCreatorPlan();
        } else {
            await handleClickStarterPlan();
        }
    };

    const isStarterPlanHidden = hideCurrentPlan && isStarter;

    return <PricingTableContainer>
            <div className='toggle'>
                <span className="text">Monthly</span>
                <Switch
                    checked={yearlyToggleValue}
                    onChange={onToggleYearly}
                    inputProps={{ 'aria-label': 'controlled' }}
                />
                <span className="text">Yearly (Save 33%)</span>
            </div>
            <Grid container spacing={0} maxWidth={"lg"} alignItems={"center"} paddingTop={"20px"}>
            {!hideFreePlan && (
                <Grid xs={12} md={4} sx={{display: "flex", justifyContent: "center", padding: "0px"}}>
                    <ProductCard 
                        title={"FREE"} 
                        checkboxStyle={isCheckboxSelectMode}
                        description={"For free users"} 
                        isCompact={small}
                        features={[
                            { text: "One-time 1,000 credits", isPositive: true },
                            { text: "Access to voice swaps, stem splits, and style samplers", isPositive: true },
                            { text: "Custom voices not included", isPositive: false },
                            { text: "Audio download unavailable", isPositive: false }
                        ]}
                        creditConversions={small ? [
                            "*Swap and Split:",
                            "- 1 credit = 1 second of audio", 
                            "*Style Sampler:",
                            "- 100 credits = 1 sample (1 min)"
                        ] : [
                            "*Swap and Split: 1 credit = 1 second of audio", 
                            "*Style Sampler: 100 credits = 1 sample (1 min)"
                        ]}
                    />
                </Grid>
            )}
            {!isStarterPlanHidden && (
                <Grid xs={12} md={columnWidth} sx={{display: "flex", justifyContent: "center"}}>
                    <ProductCard 
                        title={"STARTER"} 
                        checkboxStyle={isCheckboxSelectMode}
                        isChecked={selectedPlan === "starter"}
                        onCheckboxChange={() => handleCheckboxPlanSelection("starter")}
                        description={"For music creators"} 
                        isCompact={small}
                        features={[
                            { text: "1,000 credits per day for voice swaps, stem splits and style samples", isPositive: true },
                            { text: "1 free custom voice each month", isPositive: true },
                            { text: "Use custom voice models shared with you", isPositive: true }
                        ]}
                        creditConversions={[
                            "*Swap and Split: 1 credit = 1 second of audio", 
                            "*Style Sampler: 100 credits = 1 sample (1 min)"
                        ]}
                        priceAmount={starterPlanPrice} 
                        priceFrequency={"/mo"}
                        submitText={isStarter ? "CURRENT PLAN" : "UPGRADE"}
                        onSelect={handleClickStarterPlan} 
                        isSubmitting={isRedirectingToStarterPlan}
                        isCurrent={isStarter} 
                        isYearly={yearlyToggleValue}
                    />
                </Grid>
            )}
                

                <Grid xs={12} md={columnWidth} sx={{display: "flex", justifyContent: "center"}}>
                    <ProductCard 
                        title={"CREATOR"} 
                        checkboxStyle={isCheckboxSelectMode}
                        isChecked={selectedPlan === "creator"}
                        onCheckboxChange={() => handleCheckboxPlanSelection("creator")}
                        description={"For artists and producers"} 
                        isCompact={small}
                        features={[
                            { text: "Unlimited voice swaps, stem splits and style samples", isPositive: true },
                            { text: "3 free custom voices each month", isPositive: true },
                            { text: "Unlimited custom voices for only $10 each", isPositive: true },
                            { text: "Share custom voice models", isPositive: true },
                            { text: "Premium Support", isPositive: true }
                        ]}
                        priceAmount={creatorPlanPrice} 
                        priceFrequency={"/mo"}
                        submitText={isCreator ? "CURRENT PLAN" : "UPGRADE"}
                        onSelect={handleClickCreatorPlan} 
                        isSubmitting={isRedirectingToCreatorPlan}
                        isCurrent={isCreator} 
                        isYearly={yearlyToggleValue}
                        isPopular={true}
                    />
                </Grid>


                {!hideContractCard && (
                <Grid xs={12} md={4} sx={{display: "flex", justifyContent: "center", padding: "0px"}}>
                    <ProductCard 
                        title={"PROFESSIONAL"} 
                        checkboxStyle={isCheckboxSelectMode}
                        description={"For enterprise or professional use"} 
                        isCompact={small}
                        features={[
                            { text: "API access for custom integration and automation", isPositive: true },
                            { text: "Multiple concurrent training jobs (no queueing delays)", isPositive: true },
                            { text: "Advanced model tuning or training configurations", isPositive: true },
                            { text: "Early access to new features, models, or voices", isPositive: true },
                            { text: "Priority technical and audio support", isPositive: true }
                        ]}
                        showContactButton={true}
                        onContactClick={() => {
                            window.open('https://www.controlla.xyz/contact-4', '_blank');
                        }}
                        
                    />
                </Grid>
            )}
            </Grid>
  

            {isCheckboxSelectMode && (
                <button className="primary-button" onClick={handleUpgradeClick}>
                    Upgrade Now
                </button>
            )}
    </PricingTableContainer>;
}

const PricingTableContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    overflow: hidden;
    padding: 0;
    margin: 0;

    @media (max-width: 600px) {
        padding: 10px;
        overflow: visible;
        max-height: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
    }

  .toggle {
    display: flex;
    align-items: center;
    .text {
      font-family: "Jura";
      font-weight: 300;
      font-size: 18px;
    }
  }

  
  .primary-button {
    justify-self: flex-end;
    font-family: "Jura";
    min-height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }

.secondary-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    border-radius: 0.9375rem;
    border: 0px;
    font-size: 18px;
    padding: 0rem;
    height: 20px;
    margin-top: 10px;
  }

  .button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    padding-top: 20px;
    padding-bottom: 20px;
  }

`;